var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateAssetTab = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 260,
    viewBox: "0 0 400 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.722 88.5712L149.354 91.6573L134.993 94.7434L120.622 97.8328L109.433 100.236L102.208 66.5133L42.4804 79.3487L49.7081 113.071L56.9326 146.794L64.157 180.517L123.881 167.681L183.606 154.846L243.333 142.014L236.109 108.291L228.885 74.5684L221.66 40.8457L161.932 53.6779L169.096 87.5064",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.832 22.9996L38.6584 61.5029L42.4819 79.3499L221.655 40.8466L217.832 22.9996Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.154 180.516L42.4804 79.3486L23.9116 83.339L45.5853 184.507L64.154 180.516Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.206 66.5149L42.4804 79.3496L64.154 180.517L123.88 167.683L102.206 66.5149Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2465 93.8676C84.4931 90.3884 83.4981 85.7439 80.0241 83.494C76.5502 81.244 71.9129 82.2405 69.6664 85.7198C67.4199 89.199 68.4149 93.8435 71.8888 96.0935C75.3627 98.3434 80 97.3469 82.2465 93.8676Z",
    fill: "#4767FF",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.4 110.599L165.397 122.709",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.451 96.8467L151.362 125.724",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.311 89.4326L137.326 128.739",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.274 92.4502L123.295 131.756",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.242 95.4648L115.52 125.298",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.211 98.4795L112.574 111.546",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M243.329 142.014L236.104 108.291L56.9307 146.794L64.1553 180.517L243.329 142.014Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M228.882 74.5673L49.7054 113.071L56.93 146.794L236.107 108.29L228.882 74.5673Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.721 88.5701L149.353 91.6562L134.992 94.7423L120.621 97.8317L109.432 100.235L111.831 111.444L114.916 125.831L116.656 133.958L123.881 167.68L183.605 154.845L180.949 142.439L179.04 133.532L176.38 121.122L174.156 110.735L171.075 96.3488L169.156 87.3994",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M161.248 136.671L77.1281 154.748L79.6233 166.395L163.743 148.318L161.248 136.671Z",
    fill: "#4767FF",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M205.766 59.3735C208.088 65.5775 204.928 72.4876 198.715 74.8162C192.491 77.1478 185.573 74.0126 183.252 67.8119C182.578 66.0079 182.359 64.1353 182.568 62.3423C183.034 57.9701 185.905 54.0161 190.309 52.3639C195.672 50.3541 201.572 52.4216 204.571 57.0121C205.048 57.7377 205.445 58.5263 205.762 59.3712L205.766 59.3735Z",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M203.895 56.0822C204.218 55.8392 204.576 55.6403 204.974 55.4942C207.182 54.6683 209.633 55.7838 210.455 57.9842C211.278 60.1847 210.163 62.6265 207.956 63.4557C207.487 63.6333 207.003 63.7216 206.529 63.7237",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M184.22 69.821C183.821 70.1873 183.354 70.4833 182.82 70.6838C180.612 71.5097 178.155 70.3961 177.329 68.1967C176.507 65.9962 177.629 63.5415 179.835 62.7123C180.738 62.3745 181.682 62.3603 182.541 62.6127",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M189.805 69.085C189.805 69.085 192.437 70.2013 196.111 69.1209C200.062 67.9592 201.657 65.5998 201.657 65.5998",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.554 211.556C103.055 213.571 101.019 216.067 99.5776 227.499C99.4926 228.167 98.5074 228.167 98.4224 227.499C96.9814 216.067 94.9455 213.571 86.4462 211.556C85.8513 211.415 85.8513 210.585 86.4462 210.444C94.9455 208.429 96.9814 205.933 98.4224 194.501C98.5074 193.833 99.4926 193.833 99.5776 194.501C101.019 205.933 103.055 208.429 111.554 210.444C112.149 210.585 112.149 211.415 111.554 211.556Z",
    fill: "#071A24"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0132 211.44C31.2472 210.449 30.6333 209.455 29.6421 209.221C28.6509 208.987 27.6577 209.601 27.4237 210.593C27.1898 211.584 27.8037 212.577 28.7949 212.811C29.7861 213.045 30.7793 212.431 31.0132 211.44Z",
    fill: "#071A24"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2975 241.957C48.6707 240.376 47.6915 238.791 46.1105 238.418C44.5295 238.045 42.9453 239.024 42.5721 240.606C42.199 242.187 43.1782 243.771 44.7592 244.145C46.3402 244.518 47.9244 243.538 48.2975 241.957Z",
    fill: "#071A24"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M299.354 182.878L303.801 183.813L291.659 241.535L287.213 240.599L299.354 182.878Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M214.546 119.748L230.225 123.726C235.275 103.847 242.285 91.6468 250.494 88.4499C252.719 87.5841 255.117 87.3603 257.617 87.6095C262.866 88.1331 268.571 90.7472 274.086 93.9315C277.527 95.9121 280.892 98.1166 284.03 100.173C288.624 103.18 292.965 106.027 296.875 107.741C309.21 113.164 319.872 113.641 329.284 114.072C332.451 114.211 335.394 114.346 338.173 114.654C343.616 115.263 348.455 116.551 353.193 119.916C354.058 120.533 354.852 121.112 355.591 121.699C360.853 125.918 363.205 130.622 366.101 150.792L382.114 148.49C380.205 135.208 378.436 127.784 375.809 122.007C372.347 114.401 367.393 110.169 362.559 106.728C358.843 104.088 355.139 102.276 351.457 101.026C344.198 98.5432 337.028 98.2222 330.015 97.9055C329.913 97.9012 329.816 97.897 329.715 97.8928C321.421 97.5169 312.837 97.082 303.378 92.9306C300.701 91.7566 296.909 89.2691 292.893 86.6381C291.867 85.9667 290.807 85.2741 289.726 84.573C284.068 80.9116 277.654 77.0094 270.843 74.391C262.494 71.1857 253.542 69.9061 244.628 73.369C230.96 78.686 221.121 93.8597 214.542 119.743L214.546 119.748Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M367.045 150.336C367.045 150.336 361.374 158.866 363.992 160.856C366.605 162.845 369.261 155.927 369.261 155.927C369.261 155.927 370.055 168.428 373.079 169.462C376.102 170.497 375.351 165.155 375.351 165.155C375.351 165.155 376.254 170.978 379.172 170.733C382.094 170.489 380.131 165.074 380.131 165.074C380.131 165.074 381.537 169.146 383.994 168.635C386.452 168.119 383.745 163.356 383.745 163.356C383.745 163.356 385.316 165.987 387.271 164.851C389.23 163.715 381.613 148.634 381.613 148.634L367.053 150.34L367.045 150.336Z",
    fill: "#071A24"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M229.324 123.89C229.324 123.89 233.939 133.4 231.047 135.106C228.154 136.813 226.372 129.354 226.372 129.354C226.372 129.354 223.961 142.117 220.777 142.792C217.593 143.468 219.046 138.067 219.046 138.067C219.046 138.067 217.386 143.941 214.473 143.316C211.559 142.687 214.236 137.37 214.236 137.37C214.236 137.37 212.29 141.378 209.883 140.533C207.472 139.688 210.816 135.132 210.816 135.132C210.816 135.132 208.89 137.636 207.066 136.217C205.238 134.794 214.866 120.258 214.866 120.258L229.328 123.89H229.324Z",
    fill: "#071A24"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M323.064 52.6914C321.642 59.1162 315.287 63.169 308.868 61.7468C302.444 60.3246 298.392 53.9694 299.814 47.5396C300.226 45.6699 301.062 43.9941 302.2 42.6116C304.95 39.2202 309.47 37.4798 314.019 38.4892C319.558 39.7175 323.342 44.6306 323.347 50.0807C323.347 50.946 323.258 51.8162 323.064 52.6914Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M323.29 48.9379C323.688 48.908 324.095 48.9379 324.503 49.0324C326.78 49.5396 328.212 51.7922 327.71 54.0747C327.208 56.3572 324.956 57.7844 322.678 57.2821C322.191 57.1727 321.744 56.9887 321.351 56.7351",
    fill: "#071A24"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M323.29 48.9379C323.688 48.908 324.095 48.9379 324.503 49.0324C326.78 49.5396 328.212 51.7922 327.71 54.0747C327.208 56.3572 324.956 57.7844 322.678 57.2821C322.191 57.1727 321.744 56.9887 321.351 56.7351",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M299.533 49.7427C299.006 49.8322 298.454 49.8273 297.907 49.7079C295.63 49.2007 294.188 46.9431 294.695 44.6655C295.203 42.388 297.46 40.9459 299.737 41.4531C300.672 41.662 301.463 42.1593 302.039 42.8356",
    fill: "#071A24"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M299.533 49.7427C299.006 49.8322 298.454 49.8273 297.907 49.7079C295.63 49.2007 294.188 46.9431 294.695 44.6655C295.203 42.388 297.46 40.9459 299.737 41.4531C300.672 41.662 301.463 42.1593 302.039 42.8356",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M316.812 54.0742C312.645 55.1682 309.871 54.6958 307.961 53.7907C304.118 51.9757 303.949 46.6797 303.949 46.6797C303.949 46.6797 308.255 44.2828 312.019 46.0183C316.772 48.2113 316.812 54.0692 316.812 54.0692V54.0742Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M308.418 53.1942C307.935 50.8173 307.935 49.8426 308.671 48.6292C309.939 46.5357 312.137 46.3965 312.137 46.3965C312.137 46.3965 313.295 48.3806 312.311 50.5636C311.068 53.3136 308.423 53.1942 308.423 53.1942H308.418Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M290.395 141.445C308.37 150.288 328.817 145.504 336.071 130.761C338.554 125.71 339.166 120.148 338.174 114.658C338.094 114.214 338.009 113.771 337.908 113.328C336.662 107.867 333.841 102.533 329.716 97.9004C327.571 95.4975 325.075 93.2888 322.267 91.3461C320.515 90.1341 318.64 89.0361 316.651 88.0563C309.401 84.4877 301.749 83.1406 294.723 83.774C293.013 83.9261 291.345 84.1963 289.727 84.5764C284.099 85.9025 279.095 88.5969 275.345 92.5202C274.906 92.972 274.492 93.445 274.087 93.9307C272.879 95.3919 271.836 97.0009 270.979 98.7451C263.729 113.488 272.427 132.602 290.399 141.445H290.395Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M337.906 113.323C338.007 113.767 338.096 114.21 338.172 114.654",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M274.083 93.931C274.484 93.4454 274.903 92.9724 275.342 92.5205",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M337.906 113.323C338.007 113.767 338.096 114.21 338.172 114.654",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M274.083 93.931C274.484 93.4454 274.903 92.9724 275.342 92.5205",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M355.592 121.703C355.833 115.478 354.702 109.185 352.358 103.184C352.075 102.462 351.775 101.744 351.459 101.03",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M270.842 74.3994C265.526 77.7526 260.991 82.1911 257.617 87.6094",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M301.866 155.707L312.452 157.935L306.638 185.578L296.051 183.351L301.866 155.707Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M322.302 165.932L326.681 164.576L359.833 235.854L355.716 237.772L322.302 165.932Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M291.336 247.345H255.329L286.902 239.604L292.058 239.781L291.336 247.345Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M359.121 234.325L363.567 242.155L347.475 247.375L329.436 247.345L345.494 241.745L359.121 234.325Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M283.051 156.383C309.506 169.394 340.116 161.303 351.42 138.308C353.079 134.937 354.228 131.436 354.895 127.872C355.283 125.828 355.516 123.767 355.592 121.698C354.853 121.111 354.059 120.528 353.193 119.916C348.451 116.546 343.616 115.262 338.173 114.654C339.165 120.144 338.553 125.706 336.07 130.757C328.816 145.5 308.37 150.284 290.394 141.441C272.418 132.602 263.723 113.484 270.974 98.7409C271.835 96.9925 272.878 95.3877 274.082 93.9265C268.571 90.7423 262.862 88.1282 257.613 87.6045C256.891 88.7532 256.233 89.9483 255.62 91.1857C254.054 94.3657 252.943 97.664 252.259 101.021C247.981 121.947 260.248 145.166 283.042 156.383H283.051Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M270.839 74.3951C277.65 77.0092 284.064 80.9156 289.723 84.5771C291.34 84.1928 293.008 83.9267 294.718 83.7747C301.744 83.1412 309.396 84.4926 316.646 88.0569C318.635 89.0367 320.51 90.1347 322.262 91.3467C325.07 93.2894 327.566 95.4981 329.711 97.9011C329.812 97.9053 329.91 97.9095 330.011 97.9137C337.025 98.2262 344.195 98.5514 351.453 101.035C346.386 89.6153 336.873 79.4502 323.994 73.1197C305.739 64.1413 285.5 65.214 270.995 74.2979C270.944 74.3317 270.889 74.3613 270.839 74.3993V74.3951Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateAssetTab);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyStateAssetTab.bce7a1ce1bf12f2f952b66856423659e.svg";